module.exports = __webpack_public_path__ + "static/media/us-flag.39c3dde2.png";